const stats = [
  { value: "10+", label: "Years of Experience", icon: "ri-award-fill" },
  { value: "500+", label: "Happy Customers", icon: "ri-user-smile-fill" },
  { value: "4.9★", label: "Google Rating", icon: "ri-star-fill" },
  { value: "100%", label: "Fully Insured", icon: "ri-shield-check-fill" },
];

const reasons = [
  {
    icon: "ri-shield-check-fill",
    title: "Fully Insured & Certified",
    desc: "We carry full public liability insurance on every job, so you can have complete peace of mind.",
  },
  {
    icon: "ri-time-fill",
    title: "Reliable & Punctual",
    desc: "We respect your time. Our team always arrives when scheduled and completes every job efficiently.",
  },
  {
    icon: "ri-tools-fill",
    title: "Professional Equipment",
    desc: "We use industry-leading water-fed pole systems and eco-friendly cleaning solutions for a streak-free finish.",
  },
  {
    icon: "ri-map-pin-2-fill",
    title: "Local Experts",
    desc: "Based in Northfleet, we know the area and the properties here. We're your neighbours — not a distant call centre.",
  },
  {
    icon: "ri-thumb-up-fill",
    title: "Satisfaction Guaranteed",
    desc: "Not happy? We'll come back and re-clean for free. Your satisfaction is our number one priority.",
  },
  {
    icon: "ri-price-tag-3-fill",
    title: "Transparent Pricing",
    desc: "No hidden charges. We provide clear, honest quotes upfront — what we quote is what you pay.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[#1E88E5] font-heading font-semibold text-sm uppercase tracking-widest block mb-3">
            Why Mighty Cleaning?
          </span>
          <h2
            className="font-heading font-800 text-[#0F2040] leading-tight mb-4"
            style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.75rem)", fontWeight: 800 }}
          >
            The Trusted Window Cleaners<br />in Northfleet, Gravesend, Kent and surrounding areas.
          </h2>
          <p className="text-gray-500 font-body text-base max-w-xl mx-auto">
            Hundreds of homeowners and businesses trust us for reliable, professional window cleaning. Here&apos;s why.
          </p>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-[#EBF4FF] rounded-2xl p-6 text-center"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#1E88E5] rounded-xl mx-auto mb-4">
                <i className={`${stat.icon} text-white text-xl`}></i>
              </div>
              <div
                className="font-heading font-800 text-[#0F2040] text-3xl mb-1"
                style={{ fontWeight: 800 }}
              >
                {stat.value}
              </div>
              <p className="text-gray-500 font-body text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason) => (
            <div
              key={reason.title}
              className="flex items-start gap-4 p-6 rounded-2xl border border-gray-100 hover:border-[#1E88E5]/30 hover:bg-[#F8FAFE] transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-[#EBF4FF] rounded-xl flex-shrink-0">
                <i className={`${reason.icon} text-[#1E88E5] text-lg`}></i>
              </div>
              <div>
                <h3
                  className="font-heading font-700 text-[#0F2040] text-base mb-2"
                  style={{ fontWeight: 700 }}
                >
                  {reason.title}
                </h3>
                <p className="text-gray-500 font-body text-sm leading-relaxed">
                  {reason.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
